const scripts: { [url: string]: Promise<void> } = {};
const scriptElements: { [url: string]: HTMLScriptElement } = {};

type ScriptCallback = (element: HTMLScriptElement) => HTMLScriptElement;

export default (url: string, callback?: ScriptCallback): Promise<void> => {
  if (!(url in scripts)) {
    let element = document.createElement('script');
    element.src = url;
    if (callback) {
      element = callback(element);
    }
    scripts[url] = new Promise<void>((resolve, reject) => {
      element.onload = () => {
        scriptElements[url] = element;
        resolve();
      };
      element.onerror = reject;
      document.body.appendChild(element);
    });
  }
  return scripts[url];
};

export function unloadScript(url: string) {
  const element = scriptElements[url];
  if (element) {
    delete scriptElements[url];
    delete scripts[url];
    console.debug('Removing script element for', url);
    document.body.removeChild(element);
  }
}
